import { render, staticRenderFns } from "./indexEditor.vue?vue&type=template&id=680c144a&scoped=true"
import script from "./indexEditor.js?vue&type=script&lang=js&external"
export * from "./indexEditor.js?vue&type=script&lang=js&external"
import style0 from "./indexEditor.scss?vue&type=style&index=0&id=680c144a&prod&lang=scss&scoped=true&external"
import style1 from "./indexEditor.vue?vue&type=style&index=1&id=680c144a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680c144a",
  null
  
)

export default component.exports